import { Button } from '@cian/components';
import * as React from 'react';

import { trackOpenGeoModal } from './tracking';

const styles = require('./index.css');

export interface ILocationSwitherButtonProps {
  locationName: string;
  onClick(): void;
}

export class LocationSwitherButton extends React.Component<ILocationSwitherButtonProps> {
  public render() {
    return (
      <Button buttonStyle={styles['button']} onClick={this.handleClick} dataMark="location">
        {this.props.locationName}
      </Button>
    );
  }

  private handleClick = () => {
    trackOpenGeoModal();
    this.props.onClick();
  };
}
